import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
  navLinks: { path: string; key: string }[];
}

export default function MobileMenu({ open, onClose, navLinks }: MobileMenuProps) {
  const { t } = useTranslation();
  const location = useLocation();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />

      {/* Drawer */}
      <div className="fixed top-0 right-0 h-full w-64 bg-white p-6 shadow-xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 rounded-lg p-2 text-gray-600 hover:bg-gray-100"
          aria-label="Close menu"
        >
          <X size={24} />
        </button>

        <nav className="mt-12 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={onClose}
              className={`rounded-lg px-4 py-2 text-base font-medium transition-colors ${
                location.pathname === link.path
                  ? 'bg-primary/10 text-primary'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
            >
              {t(link.key)}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
}
